import React from "react";
import { Box, HStack, Text, VStack } from "@chakra-ui/react";
import { FiChevronRight } from "react-icons/fi";
import { useOutlet } from "react-router-dom";
import { BbpsComplainLayout } from "layouts/BbpsComplainLayout/BbpsComplainLayout";
import { Link as RouterLink } from "react-router-dom";

export const BbpsComplainPage: React.FC = () => {
  const outlet = useOutlet();

  if (outlet) {
    return <>{outlet}</>;
  }

  return (
    <BbpsComplainLayout title="24x7 Help" backTo="/">
      <VStack align="stretch" gap={4}>
        <Box>
          <Text fontSize="xl" fontWeight="bold" color="brand.900">
            BBPS Transactions & Complaints
          </Text>
        </Box>

        <VStack align="stretch" gap={2}>
          <Box
            asChild
            bg="white"
            borderWidth="1px"
            borderColor="blackAlpha.100"
            rounded="sm"
            p={4}
            _hover={{ bg: "gray.50" }}
            cursor="pointer"
          >
            <RouterLink to="/bbps/raise-txn-complaint">
              <HStack justify="space-between">
                <Text fontWeight="semibold" color="gray.800">
                  Raise a Transaction Complaint
                </Text>
                <Box as={FiChevronRight} color="gray.500" />
              </HStack>
            </RouterLink>
          </Box>

          {/* View Complaint Status */}
          <Box
            asChild
            bg="white"
            borderWidth="1px"
            borderColor="blackAlpha.100"
            rounded="sm"
            p={4}
            _hover={{ bg: "gray.50" }}
            cursor="pointer"
          >
            <RouterLink to="/bbps/view-complaint-status">
              <HStack justify="space-between">
                <Text fontWeight="semibold" color="gray.800">
                  View Complaint Status
                </Text>
                <Box as={FiChevronRight} color="gray.500" />
              </HStack>
            </RouterLink>
          </Box>

          {/* Check Transaction Status */}
          <Box
            asChild
            bg="white"
            borderWidth="1px"
            borderColor="blackAlpha.100"
            rounded="sm"
            p={4}
            _hover={{ bg: "gray.50" }}
            cursor="pointer"
          >
            <RouterLink to="/bbps/view-transaction-status">
              <HStack justify="space-between">
                <Text fontWeight="semibold" color="gray.800">
                  Check Transaction Status
                </Text>
                <Box as={FiChevronRight} color="gray.500" />
              </HStack>
            </RouterLink>
          </Box>
        </VStack>
      </VStack>
    </BbpsComplainLayout>
  );
};
